import React from 'react'

function investorGoalsSelector(investorGoalId) {
  let investorGoalData = {
    icon: null,
    title: null,
    content: '',
  }

  switch (investorGoalId) {
    case 'IG1':
      investorGoalData.icon = (
        <span className="Icon u-textColorBrandLight u-marginRight1gu u-textSizeMsrp1">
          &#x2977;
        </span>
      )
      investorGoalData.title = 'Generate Income'
      investorGoalData.content =
        'Explore more opportunities designed to generate income:'
      break
    case 'IG2':
      investorGoalData.icon = (
        <span
          className="Icon Icon--layered u-marginRight1gu u-textSizeMsrp1 Icon--layered-gray"
          data-icon="&#x268c;"
        >
          &#x25a2;
        </span>
      )
      investorGoalData.title = 'Tax Efficiency'
      investorGoalData.content =
        'Explore more opportunities designed to generate tax-exempt income:'
      break
    case 'IG3':
      investorGoalData.icon = (
        <span className="Icon u-textColorBrandLight u-marginRight1gu u-textSizeMsrp1">
          &#x223f;
        </span>
      )
      investorGoalData.title = 'Manage Market Volatility'
      investorGoalData.content =
        'Explore more opportunities designed to manage market volatility:'
      break
    case 'IG4':
      investorGoalData.icon = (
        <span
          className="Icon Icon--layered u-marginRight1gu u-textSizeMsrp1 Icon--layered-gray"
          data-icon="&#x25ef;"
        >
          &#x2912;
        </span>
      )
      investorGoalData.title = 'Navigate Rates'
      investorGoalData.content =
        'Explore more opportunities designed to navigate fluctuating interest rates:'
      break
    case 'IG5':
      investorGoalData.icon = (
        <span
          className="Icon Icon--cti Icon--layered u-marginRight1gu u-textSizeMsrp2 Icon--layered-gray"
          data-icon="&#x2759;"
          aria-hidden="true"
        >
          &#x25ae;
        </span>
      )
      investorGoalData.title = 'Grow Assets'
      investorGoalData.content =
        'Explore more opportunities designed to grow assets:'
      break
    case 'Other1':
      investorGoalData.content =
        "Explore more opportunities led by this strategy's managers:"
      break
    case 'Other2':
      investorGoalData.content =
        'Explore more opportunities designed with a similar investment approach:'
      break
    case 'Other3':
      investorGoalData.content =
        'Explore more opportunities that follow an alternative investment approach:'
      break
    case 'Other4':
      investorGoalData.content =
        'Explore more opportunities designed to generate income with our Total Return Bond Fund or Strategic Income Fund. For another product led by managers of this strategy, consider our Limited Duration Credit Fund.'
      break
    case 'Other5':
      investorGoalData.content =
        'Explore more opportunities focused on emerging markets:'
      break
    case 'Other6':
      investorGoalData.content =
        'Explore another opportunity designed to generate income with our Multi-Asset Income Fund. For another strategy designed to grow assets, consider our Convertible Securities Fund.'
      break
    case 'Other7':
      investorGoalData.content =
        'Explore more opportunities focused on higher-yielding investments:'
      break
    case 'Other8':
      investorGoalData.content =
        'Explore another opportunity designed to grow assets with our Global Strategic Equity Fund. For another strategy designed to generate income, consider our Dividend Opportunity Fund.'
      break
    case 'Other9':
      investorGoalData.content =
        'Explore another flexible, multi-asset product with our Adaptive Risk Allocation Fund. For another opportunity designed to grow assets, consider our Overseas Value Fund.'
      break
    case 'Other10':
      investorGoalData.content =
        'Explore more opportunities designed to generate income with our Strategic Income Fund or Multi-Asset Income Fund. For another strategy that invests in a portfolio of mutual funds, consider our Thermostat Fund.'
      break
    case 'Other11':
      investorGoalData.content =
        'Explore more opportunities designed to generate income with our Flexible Capital Income Fund or Strategic Income Fund. For another flexible, multi-asset product, consider our Adaptive Risk Allocation Fund.'
      break
    case 'Other12':
      investorGoalData.content =
        'Explore more opportunities designed to deliver an attractive level of income:'
      break
    case 'Other13':
      investorGoalData.content =
        'Explore another opportunity designed to manage volatility with our Adaptive Risk Allocation Fund. For another strategy that invests in a portfolio of other mutual funds, consider our Income Builder Fund.'
      break
    case 'Other14':
      investorGoalData.content =
        'Explore another opportunity designed to beat inflation with our Inflation Protected Securities Fund. For another strategy that uses an active, multi-asset approach, consider our Adaptive Risk Allocation Fund.'
      break
    case 'Other15':
      investorGoalData.content =
        "Explore another opportunity designed to generate income with our Strategic Income Fund. For another product led by this strategy's managers, consider our Quality Income Fund."
      break
    case 'Other16':
      investorGoalData.content =
        'Explore another strategy designed to generate income with our Strategic Income Fund. For more opportunities focused on emerging markets, consider our Emerging Markets Fund or Emerging Markets Consumer ETF.'
      break
    case 'Other17':
      investorGoalData.content =
        'Explore more opportunities designed to deliver an attractive level of tax-exempt income:'
      break
    case 'Other18':
      investorGoalData.content =
        'Explore more fixed-income opportunities designed to generate attractive total return:'
      break
    case 'Other19':
      investorGoalData.content =
        'Explore more opportunities designed to generate income in global fixed-income markets:'
      break
    case 'Other20':
      investorGoalData.content =
        'Explore more opportunities designed to outpace the rate of inflation:'
      break
    case 'Other21':
      investorGoalData.content =
        'Explore more opportunities designed to generate attractive total return:'
      break
    case 'Other22':
      investorGoalData.content =
        'Explore other opportunities designed to generate income and grow assets:'
      break
    case 'Other23':
      investorGoalData.content =
        'Explore more fixed-income opportunities designed to navigate a changing interest rate environment:'
      break
    case 'Other24':
      investorGoalData.content =
        'Explore more opportunities designed to deliver an appropriate balance between income and volatility:'
      break
    case 'Other25':
      investorGoalData.content =
        'Explore more funds focused on emerging markets:'
      break
    case 'Other26':
      investorGoalData.content =
        'Explore more funds designed to generate equity income:'
      break
    case 'Other27':
      investorGoalData.content =
        'Explore more opportunities designed to generate taxable income with our Strategic Income Fund or Total Return Bond Fund. For a strategic beta approach to tax-exempt income, consider our Multi-Sector Municipal Income ETF (MUST).'
      break
    case 'Other28':
      investorGoalData.content =
        'Explore more funds focused on emerging markets:'
      break
    case 'Other29':
      investorGoalData.content =
        'Explore more opportunities designed to generate tax-exempt income with our Strategic Municipal Income Fund or Tax-Exempt Fund. For a strategic beta approach to taxable income, consider our Diversified Fixed Income Allocation ETF (DIAL).'
      break
    case 'Other30':
      investorGoalData.content = 'Grow Assets to Achieve Financial Goals'
      break
    case 'Other31':
      investorGoalData.content =
        'Explore more opportunities with similar investment processes and philosophies:'
      break
    case 'Other32':
      investorGoalData.content =
        'For additional strategic beta approaches consider Diversified Fixed Income Allocation ETF (DIAL) for multi-sector fixed income, and Multi-Sector Municipal Income ETF (MUST) for tax-exempt income. Explore more fixed-income opportunities designed to navigate a changing interest rate environment with Ultra Short Term Bond Fund.'
      break
    case 'SolutionsPortfolio':
      investorGoalData.content =
        'For the other major component within the Columbia Adaptive Retirement Series click below.'
      break
    default:
      investorGoalData.content = investorGoalId
  }
  return investorGoalData
}

export default investorGoalsSelector
